import React, {FC, ReactNode} from 'react';
import {QueryClientProvider} from "@tanstack/react-query";

import './styles.css'
import '@labels/i18n'

import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'

import {LocalizationProvider} from '@mui/x-date-pickers';
import ThemeContextProvider from "@view/theme/context/ThemeContextProvider";
import ActionContextProvider from "@context/actionContext/ActionContextProvider";
import {queryClient} from "@app/appProvider/queryClient/queryClient";
import SnackBars from "@ui/snackBars/SnackBars";
import Confirm from "@ui/confirm/Confirm";
import {CssBaseline} from '@mui/material';
import {UiTheme, UiThemeSize} from "@view/theme/types";
import ViewContextProvider from "@context/viewContext/ViewContextProvider";


interface IProps {
    children: ReactNode,
    forcedTheme?: UiTheme
    forcedThemeSize?: UiThemeSize,
}

const BaseAppProvider: FC<IProps> = ({
                                         children,
                                         forcedTheme,
                                         forcedThemeSize,
                                     }) => {
    return (
        <QueryClientProvider client={queryClient}>
            {/*<ReactQueryDevtools position={'right'} initialIsOpen={false} />*/}
            <ThemeContextProvider
                forcedTheme={forcedTheme}
                forcedThemeSize={forcedThemeSize}
            >
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <ViewContextProvider>
                        <ActionContextProvider>
                            <CssBaseline/>
                            <SnackBars/>
                            <Confirm/>

                            {children}
                        </ActionContextProvider>
                    </ViewContextProvider>
                </LocalizationProvider>
            </ThemeContextProvider>
        </QueryClientProvider>
    );
};

export default BaseAppProvider;